import { ViewDensity, ViewType } from "@common/types/views/views";
import {
    FinancialDocumentView,
    FinancialDocumentColumn,
} from "@common/types/views/financialDocumentViews";

export const defaultFinancialDocumentView: FinancialDocumentView = {
    type: ViewType.FINANCIAL_DOCUMENT,
    columns: [
        { id: FinancialDocumentColumn.UPLOAD_DATE, options: { pin: "left" } },
        { id: FinancialDocumentColumn.NAME, options: { pin: "left" } },
        { id: FinancialDocumentColumn.DOCUMENT_CATEGORY },
        { id: FinancialDocumentColumn.COUNTERPARTY },
        { id: FinancialDocumentColumn.PERIOD },
        { id: FinancialDocumentColumn.MATCHED_TRANSACTION },
        { id: FinancialDocumentColumn.FINANCIAL_ACCOUNT },
        { id: FinancialDocumentColumn.UPLOADER },
        { id: FinancialDocumentColumn.ENTITY },
        { id: FinancialDocumentColumn.STATUS },
        { id: FinancialDocumentColumn.ACTIONS, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: true,
        bulkActions: true,
        density: ViewDensity.MD,
    },
};
